import { Component, OnInit, OnChanges, Input, SimpleChanges, signal, inject } from '@angular/core';

import { AvatarService } from './avatar.service';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';

import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LoggerService } from '@app/shared/services/logger.service';
import { Observable } from 'rxjs';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: true,
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() userId: string;
  @Input() isFriend: boolean;

  componentDestroy: () => Observable<unknown>;
  avatarUrl = signal('');
  defaultAvatarUrl = `${environment.CDN}portal/avatars/default.jpg`;

  private readonly logger = inject(LoggerService);
  private readonly avatarService = inject(AvatarService);

  ngOnInit() {
    this.avatarService.avatar$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (userId: string) => {
        if (this.userId === userId) {
          this.setAvatarUrl(this.userId);
        }
      },
      error: (error) => this.logger.error(error),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.userId || !changes.userId.currentValue) return;
    if (!changes.userId.previousValue || changes.userId.currentValue !== changes.userId.previousValue) {
      this.setAvatarUrl(changes.userId.currentValue);
    }
  }

  setAvatarUrl(userId: string): void {
    this.avatarService
      .getUserAvatarUrl(userId)
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe({
        next: (avatarUrl: string) => {
          setTimeout(() => {
            this.avatarUrl.set(this.normalizeUrl(avatarUrl));
          });
        },
        error: (error) => this.logger.error(error),
      });
  }

  private normalizeUrl(url: string): string {
    if (!url) return this.defaultAvatarUrl;

    if (url.startsWith('//')) {
      return `https:${url}`;
    }

    return url;
  }
}
